import { i18n } from '@/lang';
import { StoreHelper } from 'Helpers/storeHelper'
import { ApiService } from '../../../services/apiService'
import { compare } from 'fast-json-patch'
import { campaignStatus, campaignType } from 'Features/bizgainOnboarding/constants';
const {
  getRoimaticCampaign,
  updateAdditionalConfiguration,
  getRoimaticCampaigns
} = new ApiService();
export const state = {
  roimaticCampaign: StoreHelper.state(null),
  isUpdateAddtionalConfig: false,
  isErrorAddtioanlConfig: false,
  creativeImages: [],
  creativeLogos: {},
  creativeLeadImages: [],
  bizgainMessage: [],
  isCreativeEdited: false,
  draftCampaigns: [],
  isCampaignEdited: false,
  sessionId: null,
  presetImage: null,
  isPresetImageSet: false,
  businessDetailsOptions: {
    isWebsiteSelected: false,
    isGoogleMapsSelected: false,
    isFacebookSelected: false,
    isNoneOfTheAboveSelected: false
  }

};
export const getters = {
  isCreativeEdited: state => state.isCreativeEdited,
  roimaticCampaign: state => state.roimaticCampaign.data,
  additionalConfiguration: state => state.roimaticCampaign.data && state.roimaticCampaign.data.additionalConfiguration,
  isUpdateAddtionalConfig: state => state.isUpdateAddtionalConfig,
  isErrorAddtioanlConfig: state => state.isErrorAddtioanlConfig,
  creativeImages: state => state.creativeImages,
  creativeLogos: state => state.creativeLogos,
  creativeLeadImages: state => state.creativeLeadImages,
  currencySymbol: (state, getters, rootState, rootGetters) => {
    return rootGetters.currencyInfo && rootGetters.currencyInfo.symbol
  },
  roimaticCampaignId: (state, getters, rootState, rootGetters) => {
    return rootGetters.selectedCampaignId ? rootGetters.selectedCampaignId : getters && getters.roimaticCampaign && getters.roimaticCampaign.id
  },
  bizgainMessage: state => state.bizgainMessage,
  draftCampaigns: state => state.draftCampaigns,
  isCampaignEdited: state => state.isCampaignEdited,
  sessionId: state => state.sessionId,
  presetImage: state => state.presetImage,
  businessDetailsOptions: state => state.businessDetailsOptions
};

export const mutations = {
  updateMessage(state, error) {
    state.bizgainMessage.push(error);
  },
  clearMessages(state) {
    state.bizgainMessage = [];
  },
  setIsCreativeEdited(state, isCreativeEdited) {
    state.isCreativeEdited = isCreativeEdited;
  },
  setRoimaticCampaign(state, roimaticCampaign) {
    state.roimaticCampaign = StoreHelper.updateState(state.roimaticCampaign, roimaticCampaign);
  },
  updateAdditionalConfiguration(state, additionalConfiguration) {
    if (additionalConfiguration) {
      state.roimaticCampaign.data.additionalConfiguration = additionalConfiguration;
    }
  },
  setIsUpdateAddtionalConfig(state, payload) {
    state.isUpdateAddtionalConfig = payload;
  },
  setIsErrorAddtioanlConfig(state, payload) {
    state.isErrorAddtioanlConfig = payload;
  },
  setCreativeImages(state, payload) {
    let existingImage = state.creativeImages.find(creativeImage =>creativeImage.templateId === payload.templateId);
    if (existingImage) {
      state.creativeImages.splice(state.creativeImages.indexOf(existingImage), 1);
    }
    state.creativeImages.unshift(payload);
  },
  addCreativeLogo(state, payload) {
    state.creativeLogos = payload;
  },
  addCreativeLeadImage(state, payload) {
    state.creativeLeadImages = payload;
  },
  clearCreativeImages(state, exclude) {
    if (exclude) {
      state.creativeImages = state.creativeImages.filter(creativeImage=>exclude.includes(creativeImage.templateId));
    } else {
      state.creativeImages = [];
    }
  },
  resetRoimaticCampaign(state) {
    state.roimaticCampaign = StoreHelper.state(null)
  },
  setDraftCampaigns(state, payload) {
    state.draftCampaigns = payload;
  },
  deleteDraftCampaign(state, payload) {
    if (state.draftCampaigns.indexOf(payload) != -1) {
      state.draftCampaigns.splice(state.draftCampaigns.indexOf(payload), 1);
    }
  },
  setIsCampaignEdited(state, payload) {
    state.isCampaignEdited = payload;
  },
  setSessionId(state, payload) {
    state.sessionId = payload;
  },
  setPresetImage(state, item){
    state.presetImage = item
  },
  setBusinessDetailsOptions(state, payload) {
    state.businessDetailsOptions = payload;
  }
};

export const actions = {
  clearMessages(context) {
    context.commit('clearMessages');
  },
  updateMessage(context, payload) {
    context.commit('updateMessage', payload);
  },
  clearCreativeImages(context) {
    context.commit('clearCreativeImages');
  },
  setIsCreativeEdited(context, payload) {
    context.commit('setIsCreativeEdited', payload);
  },
  clearCreativeImages(context, payload) {
    context.commit('clearCreativeImages', payload);
  },
  addCreativeLogo(context, payload) {
    context.commit('addCreativeLogo', payload);
  },
  addCreativeLeadImage(context, payload) {
    context.commit('addCreativeLeadImage', payload);
  },
  setCreativeImages(context, payload) {
    context.commit('setCreativeImages', payload);
  },
  setPresetImage(context, payload) {
    context.commit('setPresetImage', payload);
  },
  async getRoimaticCampaign(context, payload) {
    if (payload && payload.campaignId && payload.businessProfileId) {
      try {
        context.commit('clearMessages');
        context.commit('setRoimaticCampaign');
        let roimaticCampaign = await getRoimaticCampaign(payload.businessProfileId, payload.campaignId);
        if (roimaticCampaign) {
          context.commit('setRoimaticCampaign', roimaticCampaign);
        }
      } catch (error) {
        if (payload && payload.disableErrorHandling) {
          throw error;
        } else {
          context.commit('setRoimaticCampaign', error);
          context.commit('updateMessage', { type: 'error',  text: i18n.tc('message.bizgainOnboarding.failedToFetchCampaign') });
        }
      }
    }
  },
  async patchAdditionalConfiguration(context, payload) {
    if (payload && payload.businessProfileId, payload.campaignId, payload.oldAddtionalConfig, payload.newAddtionalConfig) {
      try {
        context.commit('clearMessages');
        context.commit('setIsUpdateAddtionalConfig', true);
        let jsonPatch = compare(payload.oldAddtionalConfig, payload.newAddtionalConfig);
        if (jsonPatch && Array.isArray(jsonPatch) && jsonPatch.length > 0) {
          await updateAdditionalConfiguration(payload.businessProfileId, payload.campaignId, jsonPatch);
          context.commit('updateAdditionalConfiguration', payload.newAddtionalConfig);
        }
      } catch (error) {
        context.commit('setIsErrorAddtioanlConfig', true);
        context.commit('updateMessage', { type: 'error',  text: i18n.tc('message.bizgainOnboarding.failedToUpdateAdditionalConfig') });
      } finally {
        context.commit('setIsUpdateAddtionalConfig', false);
      }
    }
  },
  setIsInAppCampaign(context, payload) {
    context.commit('setIsInAppCampaign', payload);
  },
  resetRoimaticCampaign(context) {
    context.commit('resetRoimaticCampaign');
  },
  async getDraftRoimaticCampaigns(context) {
    if (context.getters.businessProfileId) {
      try {
        context.commit('clearMessages');
        let statuses = [campaignStatus.NEW];
        let campaigns = await getRoimaticCampaigns(context.getters.businessProfileId, statuses);
        if (campaigns) {
          campaigns.forEach(campaign => {
            campaign.type = campaignType.Draftcampaign
          });
          context.commit('setDraftCampaigns', campaigns);
        };
      } catch (error) {
        context.commit('updateMessage', { type: 'error',  text: i18n.tc('message.bizgainOnboarding.failedToFetchCampaigns') });
      }
    }
  },
  deleteDraftCampaign(context, payload) {
    context.commit('deleteDraftCampaign', payload);
  },
  setIsCampaignEdited(context, payload) {
    context.commit('setIsCampaignEdited', payload);
  },
  setSessionId(context, payload) {
    context.commit('setSessionId', payload);
  },
  setRoimaticCampaign(context, payload) {
    context.commit('setRoimaticCampaign', payload);
  },
  setBusinessDetailsOptions(context, payload) {
    context.commit('setBusinessDetailsOptions', payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}